import { render, staticRenderFns } from "./PendingBlock.vue?vue&type=template&id=0754d5d1&scoped=true"
import script from "./PendingBlock.vue?vue&type=script&lang=js"
export * from "./PendingBlock.vue?vue&type=script&lang=js"
import style0 from "./PendingBlock.vue?vue&type=style&index=0&id=0754d5d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0754d5d1",
  null
  
)

export default component.exports